import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import EastIcon from '@mui/icons-material/East';


const ContactSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        color: "white",
        padding: { xs: "60px 6%", md: "80px 5%" },
        gap: { xs: 6, md: 8 },
        alignItems: "flex-start",
        mb:5
      }}
    >
      {/* LEFT SIDE */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          paddingRight: { xs: 0, md: "5%" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: { xs: "center", md: "flex-start" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Button
          variant="outlined"
          sx={{
            color: "#000",
            borderColor: "#000",
            borderRadius: "30px",
            padding: "6px 18px",
            width: "fit-content",
            textTransform: "none",
            mb: 3,
            "&:hover": {
              borderColor: "#000",
            },
          }}
        >
          ● Get in Touch
        </Button>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            lineHeight: 1.3,
            mb: 4,
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.8rem" },
            color:"#000"
          }}
        >
         Let’s connect and make your wellness journey more mindful.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 4, sm: 8 },
            mt: 3,
            alignItems: { xs: "flex-start", sm: "flex-start" },
            color:"#000"
          }}
        >
          <Box >
            <Typography variant="subtitle2" sx={{ opacity: 0.7, mb: 1 }}>
              Address
            </Typography>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              5609 E Sprague Ave, Spokane <br />
              Valley, WA 99212, USA
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" sx={{ opacity: 0.7, mb: 1 }}>
              Support
            </Typography>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              +(084) 456-0789 <br />
              Support@Example.Com
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* RIGHT SIDE */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          display: "flex",
          flexDirection: "column",
          gap: { xs: 2.5, sm: 3 },
        }}
      >
        {/* Row 1 */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <TextField
            label="Full Name *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#F4F4F4",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          <TextField
            label="Phone *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#F4F4F4",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />
        </Box>

        {/* Row 2 */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <TextField
            label="Email Address *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#F4F4F4",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          <TextField
            select
            label="Services *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#F4F4F4",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          >
            <MenuItem value="Web Design">Web Design</MenuItem>
            <MenuItem value="Development">Development</MenuItem>
            <MenuItem value="SEO">SEO</MenuItem>
            <MenuItem value="Branding">Branding</MenuItem>
          </TextField>
        </Box>

        {/* Message */}
        <TextField
          label="Write Message *"
          variant="filled"
          multiline
          rows={5}
          fullWidth
          InputProps={{
            disableUnderline: true,
            sx: {
              backgroundColor: "#F4F4F4",
              borderRadius: "20px",
              color: "white",
            },
          }}
          InputLabelProps={{ style: { color: "#aaa" } }}
        />

        {/* Button */}
      

          <Button
      variant="contained"
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        borderRadius: "50px",
        px:1,
        width:"30%",
        textTransform: "none",
        fontWeight: 500,
        fontSize: { xs: "0.9rem", md: "1rem" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        "&:hover": { backgroundColor: "#000" },
      }}
    >
      <Typography sx={{paddingLeft:1}}> Send Message</Typography>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "50%",
          width: { xs: 30, md: 34 },
          height: { xs: 30, md: 34 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EastIcon sx={{ color: "#000", fontSize: "1.1rem" }} />
      </Box>
    </Button>
      </Box>
    </Box>
  );
};

export default ContactSection;
